import React from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/views/ChangeNumberWrapperStyle';
import { makeStyles } from '@material-ui/core';
import TabsWithDots, { ITab } from 'components/TabsWithDots/TabsWithDots';
import Button from 'components/CustomButtons/Button';

// @ts-ignore
const useStyles = makeStyles(styles);

interface ISingleButton {
	color: types.theme.buttonColor;
	text: string;
	onClick: () => void;
	disabled?: boolean;
	id?: string;
}

interface IAddNewServiceProps {
	tabs: ITab[];
	activeTab: number;
	setActiveTab: React.Dispatch<React.SetStateAction<number>>;
	buttons: ISingleButton[];
	width?: number;
	isNewDashBoardEnabled?: boolean;
}

const ChangeNumberWrapper = ({
	tabs,
	activeTab,
	setActiveTab,
	buttons,
	width = 624,
	isNewDashBoardEnabled,
}: IAddNewServiceProps) => {
	const classes = useStyles({ isNewDashBoardEnabled });

	return (
		<div className={classes.changePasswordWrapper}>
			<TabsWithDots
				tabs={tabs}
				activeTab={activeTab}
				setActiveTab={setActiveTab}
				contentClasses={classes.contentWrapper}
				footer={
					<div className={classes.footer}>
						{buttons.map((button, index) => (
							<Button
								key={index}
								color={button.color}
								onClick={button.onClick}
								disabled={button.disabled}
								id={button.id}
							>
								{button.text}
							</Button>
						))}
					</div>
				}
				isNewDashBoardEnabled={isNewDashBoardEnabled}
			/>
		</div>
	);
};

export default ChangeNumberWrapper;
